import type { ApiClient } from "@/lib/api";
import type {
  GatewaySuggestion,
  ResolveGatewaySuggestionRequest,
} from "../types";

export const resolveGatewaySuggestion = async ({
  client,
  gatewayId,
  suggestionId,
  payload = {},
}: {
  client: ApiClient;
  gatewayId: string;
  suggestionId: string;
  payload?: ResolveGatewaySuggestionRequest;
}): Promise<GatewaySuggestion | null> => {
  const response = await client.post<GatewaySuggestion | undefined>(
    `/gateways/${encodeURIComponent(gatewayId)}/suggestions/${encodeURIComponent(suggestionId)}/resolve`,
    payload
  );

  return response.data ?? null;
};
